import React from 'react';
import Icon from './Icon';

const PlusIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 5V19M5 12H19"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default PlusIcon;